<template>
    <ies-form-field :field="field">
        <input type="hidden" :name="field.fieldName" :value="field.value">

        <label for="monthly">Monthly:</label>
        <input name="monthly" type="checkbox" v-model="subscriptions.monthly">
        <label for="specialOffers">Special Offers:</label>
        <input name="specialOffers" type="checkbox" v-model="subscriptions.specialOffers">
        <label for="family">Family:</label>
        <input name="family" type="checkbox" v-model="subscriptions.family">
    </ies-form-field>
</template>

<script>
    /**
     * Allows the user to select newsletter subscription types based
     * on their name
     *
     * The database stores these values as integers/tinyintegers
     * with each day represented as a boolean value by one bit, but the
     * user expects to interact with them using checkboxes to toggle
     * each type separately, meaning we will display several checkboxes per
     * field.  We will use view models to abstract the data from the 
     * data model it is representing as it will make it cleaner and
     * safer to modify the UI, provided we keep the two models in 
     * synchronisation
     *
     */
    export default {
        name: 'ies-newsletter-subscriptions',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                /** @var object week - A view model representing the newsletters as a boolean flag for each - this will be used to power the UI easier than the data model */
                subscriptions: {'monthly': false, 'specialOffers': false, 'family':false},
            }
        },
        methods: {
            /**
             * Update the view models so that the view model data 
             * reflects the underlying data model for the field 
             * which will actually be saved to the database later
             */
            updateViewFromModel: function(){
                this.subscriptions.monthly = this.field.value & 1;
                this.subscriptions.specialOffers = this.field.value & 2;
                this.subscriptions.family = this.field.value & 4;
            },

            /**
             * Update the data model for the field to match the data
             * represented in the view model which powers the user 
             * interface so that it matches what the user has entered
             */
            updateModelFromView: function(newValue){
                this.field.value = (this.subscriptions.monthly)   ? this.field.value |= 1  : this.field.value & ~1;
                this.field.value = (this.subscriptions.specialOffers)  ? this.field.value |= 2  : this.field.value & ~2;
                this.field.value = (this.subscriptions.family)? this.field.value |= 4  : this.field.value & ~4;
            }
        },

        created:function() {
            this.updateViewFromModel();
        },

        /**
         * In the event that the user changes the view model's data then
         * we need to trigger a corresponding change to the data model too
         */
        watch: {
            'subscriptions.monthly':    function(){ this.updateModelFromView(); },
            'subscriptions.specialOffers':   function(){ this.updateModelFromView(); },
            'subscriptions.family': function(){ this.updateModelFromView(); },
        }
    }
</script>
